import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { supabase } from 'utils/supabase'
import { CandidateTableRowTypes } from 'admin/components/CandidatesTable'
import { useNavigate } from 'react-router-dom'
import { mobileCss } from 'utils/theme'

interface StateTypes {
  success: CandidateTableRowTypes[] | []
  innovation: CandidateTableRowTypes[] | []
  charity: CandidateTableRowTypes[] | []
}

const initialValues: StateTypes = {
  success: [],
  innovation: [],
  charity: []
}

const BrochureList = () => {
  const [candidates, setCandidates] = useState<StateTypes>(initialValues)
  const navigate = useNavigate()

  const getCandidates = async () => {
    try {
      const response = await supabase
        .from('candidates')
        .select()

      const data = response.data as CandidateTableRowTypes[]

      const success = data
        .filter(candidate => candidate.type === 'success')
        .sort((a, b) => a.sortingName.localeCompare(b.sortingName))
      const innovation = data
        .filter(candidate => candidate.type === 'innovation')
        .sort((a, b) => a.sortingName.localeCompare(b.sortingName))
      const charity = data
        .filter(candidate => candidate.type === 'charity')
        .sort((a, b) => a.sortingName.localeCompare(b.sortingName))

      setCandidates({
        success,
        innovation,
        charity
      })
    } catch (err) {
      console.error(err)
    }
  }
  
  useEffect(() => {
    getCandidates()
  }, [])

  const handleGoToCandidate = (id: string) => {
    navigate(`/broszura/wszyscy#candidate-${id}`)
  }

  return (
    <PageWrapper>
      <Title>Kandydatury do Nagrody PRB</Title>

      <Section>
        <SectionHeader>SUKCES</SectionHeader>
        <List>
          {candidates.success.map(candidate => (
            <ListItem key={candidate.id}>
              <ListButton onClick={() => handleGoToCandidate(candidate.id)}>
                {candidate.imageUrl && (
                  <AvatarWrapper>
                    <Avatar src={candidate.imageUrl} alt={candidate.nominee || 'candidate'} />
                  </AvatarWrapper>
                )}
                <Name>{candidate.nominee}</Name>
              </ListButton>
            </ListItem>
          ))}
        </List>
      </Section>

      <Section>
        <SectionHeader>WIZJA I INNOWACJE</SectionHeader>
        <List>
          {candidates.innovation.map(candidate => (
            <ListItem key={candidate.id}>
              <ListButton onClick={() => handleGoToCandidate(candidate.id)}>
                {candidate.imageUrl && (
                  <AvatarWrapper>
                    <Avatar src={candidate.imageUrl} alt={candidate.nominee || 'candidate'} />
                  </AvatarWrapper>
                )}
                <Name>{candidate.nominee}</Name>
              </ListButton>
            </ListItem>
          ))}
        </List>
      </Section>

      <Section>
        <SectionHeader>DZIAŁALNOŚĆ SPOŁECZNA</SectionHeader>
        <List>
          {candidates.charity.map(candidate => (
            <ListItem key={candidate.id}>
              <ListButton onClick={() => handleGoToCandidate(candidate.id)}>
                {candidate.imageUrl && (
                  <AvatarWrapper>
                    <Avatar src={candidate.imageUrl} alt={candidate.nominee || 'candidate'} />
                  </AvatarWrapper>
                )}
                <Name>{candidate.nominee}</Name>
              </ListButton>
            </ListItem>
          ))}
        </List>
      </Section>
    </PageWrapper>
  )
}

export default BrochureList

const PageWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 16px;

  ${mobileCss(`
    padding: 24px 12px;
  `)};
`

const Title = styled.h1`
  font-size: 32px;
  margin-bottom: 32px;
  text-align: center;
  color: #444;
`

const Section = styled.section`
  &:not(:first-of-type) {
    margin-top: 40px;
  }
`

const SectionHeader = styled.h2`
  font-size: 20px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.primary};
`

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const ListItem = styled.li`
  padding: 10px 0;

  &:not(:last-of-type) {
    border-bottom: 1px solid #eee;
  }
`

const ListButton = styled.button`
  background: none;
  border: none;
  padding: 6px 4px;
  cursor: pointer;
  color: #444;
  text-align: left;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background-color: #fafafa;
  }
`

const AvatarWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
`

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Name = styled.span`
  font-size: 16px;
`


